/**
 * Chirurgie orthopédique — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: ORTH
 * Catalogue acts (NGAP Maroc): 183
 */
import { defineSpecialty } from "../types";

export const chirurgie_orthopedique = defineSpecialty(
{
  "id": "chirurgie-orthopedique",
  "label": "Chirurgie orthopédique",
  "short": "Orthopédie",
  "scope": "Traumatologie & ostéosynthèse",
  "aliases": [
    "ORTH"
  ],
  "doctorSpecs": [
    "Chirurgie orthopédique",
    "Traumatologie"
  ],
  "featureFlag": "ux.v2.chirurgie-orthopedique",
  "theme": {
    "primary": "oklch(0.68 0.15 250)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 2,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "surgery",
      "label": "Bloc",
      "icon": "Syringe",
      "route": "/clinical/surgery",
      "order": 3,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 4,
      "requires": []
    },
    {
      "id": "rehab",
      "label": "Rééducation",
      "icon": "Activity",
      "route": "/clinical/rehab",
      "order": 5,
      "requires": [
        "kine"
      ]
    }
  ],
  "panels": [
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "component": "ClinicalImageGallery",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Chirurgie orthopédique",
    "subSpecialties": [
      "Consultation",
      "Ostéosynthèse",
      "Prothèse",
      "Arthroscopie"
    ],
    "catalogueActs": 183
  },
  "terminology": {
    "icd10": [
      "S00",
      "S72",
      "S82",
      "M17",
      "M54"
    ],
    "loinc": [
      "24506-6",
      "38265-5"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "xray-portable",
    "ultrasound-msk",
    "ortho-c-arm"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default chirurgie_orthopedique;
